import React from 'react'
import ReactDOM from 'react-dom'
import SensorealWebfeed from './components/SensorealWebfeed'

// Check for Sensoreal mode early
const urlParams = new URLSearchParams(window.location.search);
const crmParam = urlParams.get('crm');

// Render based on mode
if (crmParam === 'sensoreal') {
  console.log('Sensoreal mode detected - Minimal loading');
  // Render only Sensoreal webfeed - no heavy dependencies loaded
  ReactDOM.render(
    <SensorealWebfeed />,
    document.getElementById('root'),
  );
} else {
  console.log('Normal mode detected - Loading full app');
  // Load Mapbox CSS for normal mode
  // Load Mapbox Assembly CSS
  const assemblyLink = document.createElement('link');
  assemblyLink.rel = 'stylesheet';
  assemblyLink.href = 'https://api.mapbox.com/mapbox-assembly/mbx/v0.18.0/assembly.min.css';
  document.head.appendChild(assemblyLink);

  // Load Mapbox GL CSS
  const mapboxGLLink = document.createElement('link');
  mapboxGLLink.rel = 'stylesheet';
  mapboxGLLink.href = 'https://api.tiles.mapbox.com/mapbox-gl-js/v1.6.1/mapbox-gl.css';
  document.head.appendChild(mapboxGLLink);

  // Use dynamic imports to load heavy dependencies only when needed
  (async () => {
    const { Provider } = await import('react-redux');
    const { default: configureStore } = await import('./redux/store');
    const { default: mapboxgl } = await import('mapbox-gl');
    // eslint-disable-next-line import/no-webpack-loader-syntax
    const { default: MapboxWorker } = await import('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker');
    const { default: App } = await import('./App');
    const serviceWorker = await import('./serviceWorker');

    // Render normal app with all features
    mapboxgl.workerClass = MapboxWorker; // Wire up loaded worker to be used instead of the default

    ReactDOM.render(
      <React.Fragment>
        <Provider store={configureStore()}>
          <App />
        </Provider>
      </React.Fragment>,
      document.getElementById('root'),
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
  })();
}
// import React from 'react'
// import ReactDOM from 'react-dom'
// import { Provider } from 'react-redux'
// import configureStore from './redux/store'
// import mapboxgl from 'mapbox-gl'
// // eslint-disable-next-line import/no-webpack-loader-syntax
// import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker';

// import App from './App'
// import * as serviceWorker from './serviceWorker'

// mapboxgl.workerClass = MapboxWorker; // Wire up loaded worker to be used instead of the default

// ReactDOM.render(
//   <React.Fragment>
//     <Provider store={configureStore()}>
//       <App />
//     </Provider>
//   </React.Fragment>,
//   document.getElementById('root'),
// )

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()

